import React from 'react';
import { FileText, Film, ArrowRight } from 'lucide-react';
import Reveal from './Reveal';
import { SectionMarker } from './Gap';
import DownloadGate from './DownloadGate';

const items = [
  {
    key: 'profile',
    label: 'Studio Profile (PDF)',
    asset: 'profile',
    path: '/api/downloads/profile.pdf',
    Icon: FileText,
    desc: 'A concise overview of who we are, our six crafts, the clients we work with and how to reach us.',
    meta: 'PDF · A4',
  },
  {
    key: 'video',
    label: 'Credential Showreel',
    asset: 'credential-video',
    path: '/api/downloads/credential-video',
    Icon: Film,
    desc: 'Our showreel: a fast, cinematic look at the experiences we design and engineer.',
    meta: 'MP4 · HD',
  },
];

const Downloads = () => {
  return (
    <section id="downloads" data-testid="downloads-section" className="relative section-pad border-t border-[var(--border)]">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10">
        <Reveal><SectionMarker index="IX" label="TAKE US WITH YOU" className="label-gap" /></Reveal>
        <Reveal>
          <h3 className="font-display font-medium text-[clamp(1.8rem,4vw,3rem)] leading-[1.05] tracking-[-0.02em] w-full mb-4">
            Download our <span className="font-serif-c italic text-[var(--accent)] font-normal">profile &amp; showreel.</span>
          </h3>
        </Reveal>
        <Reveal delay={80}><p className="label label-gap">Everything you need to share Empax internally, in one place</p></Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {items.map((it, i) => (
            <Reveal key={it.key} delay={i * 90}>
              <DownloadGate asset={it.asset} assetLabel={it.label} downloadPath={it.path} testid={`download-${it.key}`}>
                <button
                  type="button"
                  data-testid={`download-card-${it.key}`}
                  className="group w-full h-full text-left relative rounded-2xl border border-[var(--border)] hover:border-[var(--accent)]/50 bg-[var(--bg-2)] p-8 md:p-10 transition-colors duration-500"
                >
                  <div className="flex items-start justify-between gap-6">
                    <div className="w-14 h-14 rounded-xl bg-[var(--accent-soft)] flex items-center justify-center text-[var(--accent)] shrink-0">
                      <it.Icon size={24} strokeWidth={1.6} />
                    </div>
                    <span className="w-11 h-11 rounded-full border border-[var(--border-strong)] flex items-center justify-center group-hover:bg-[var(--accent)] group-hover:border-[var(--accent)] transition-all duration-300">
                      <ArrowRight size={18} className="text-[var(--muted)] group-hover:text-[#0A0D17] transition-colors" />
                    </span>
                  </div>
                  <h4 className="font-display font-medium text-[clamp(1.3rem,2.4vw,1.9rem)] tracking-[-0.01em] mt-8">{it.label}</h4>
                  <p className="text-[var(--muted)]  font-light mt-3 leading-relaxed max-w-[42ch]">{it.desc}</p>
                </button>
              </DownloadGate>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Downloads;
